import { IconButton } from "@mui/material";
import CloseButton from  "@mui/icons-material/Close";


const FloodMapLoadingMsg = ({ setShowMsg, message }) => {
    return (
        <div style={{
            position: "absolute",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#f8d7da",
            color: "#721c24",
            padding: "10px 20px",
            borderRadius: "5px",
            fontSize: "16px",
            fontWeight: "bold",
            textAlign: "center",
            boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
            zIndex: 1000
        }}>
            <span>{message}</span>
            <IconButton 
                onClick={() => setShowMsg(false)}
                style={{ marginLeft: "10px", color: "#721c24" }}
            >
                <CloseButton />
            </IconButton>
        </div>
    )
};

export default FloodMapLoadingMsg;
